/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type DeleteDocumentInput = {
    clientMutationId: string;
    documentId: string;
    tenantId: string;
};
export type DocumentInspectorColumnDeleteDocumentMutationVariables = {
    input: DeleteDocumentInput;
};
export type DocumentInspectorColumnDeleteDocumentMutationResponse = {
    readonly deleteDocument: {
        readonly errors: ReadonlyArray<{
            readonly code: string | null;
            readonly path: ReadonlyArray<string | null> | null;
            readonly message: string | null;
        } | null> | null;
    } | null;
};
export type DocumentInspectorColumnDeleteDocumentMutation = {
    readonly response: DocumentInspectorColumnDeleteDocumentMutationResponse;
    readonly variables: DocumentInspectorColumnDeleteDocumentMutationVariables;
};



/*
mutation DocumentInspectorColumnDeleteDocumentMutation(
  $input: DeleteDocumentInput!
) {
  deleteDocument(input: $input) {
    errors {
      code
      path
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "DeleteDocumentPayload",
            "kind": "LinkedField",
            "name": "deleteDocument",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "InputError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "code",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "path",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "DocumentInspectorColumnDeleteDocumentMutation",
            "selections": (v1 /*: any*/),
            "type": "RootMutationType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "DocumentInspectorColumnDeleteDocumentMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "274288e2ae40f4340628fbdd2ab4b62e",
            "id": null,
            "metadata": {},
            "name": "DocumentInspectorColumnDeleteDocumentMutation",
            "operationKind": "mutation",
            "text": "mutation DocumentInspectorColumnDeleteDocumentMutation(\n  $input: DeleteDocumentInput!\n) {\n  deleteDocument(input: $input) {\n    errors {\n      code\n      path\n      message\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '4c550d6fdab4ca821ab8547712c09d03';
export default node;
